// extracted by mini-css-extract-plugin
export var column = "_sg-0";
export var divider = "_sg-2";
export var timePicker = "_sg-1";